import { styled } from '../../../config'
import { modalPadding } from '../constants'

export const Footer = styled('div', {
  display: 'flex',
  justifyContent: 'end',
  padding: `32px ${modalPadding}`
})
